<script setup lang="ts">
import { ref, useAttrs } from 'vue';
import { apiGetPreviewUrl } from '@ilteducation/content';
import dummyImageUrl from '../assets/materials/dummy-cover.png';

type Props = {
  id: string;
  duplicatesCount?: number;
  isRounded?: boolean;
  previewUrl?: string;
};

const props = withDefaults(defineProps<Props>(), {
  duplicatesCount: 0,
  isRounded: true,
  previewUrl: '',
});

const placeHolder = ref(
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO88R8AArUB2TtNwp8AAAAASUVORK5CYII=',
);
const dummyImage = dummyImageUrl;
const attrs = useAttrs();
const getPreview = apiGetPreviewUrl(props.id, 500); // define the image height for the preview from server;
</script>

<template>
  <slot name="coverFeatures"></slot>
  <v-img
    ref="coverRef"
    class="material-cover bg-surface-container-low"
    :class="isRounded ? 'rounded-lg' : 'rounded-0'"
    v-bind="attrs"
    :lazy-src="placeHolder"
    :src="previewUrl === '' ? getPreview : previewUrl"
    tabindex="0"
  >
    <template #error>
      <v-img v-bind="attrs" :src="dummyImage" />
    </template>
  </v-img>
</template>

<style scoped lang="scss"></style>
